import IllustratorLogin from "../../Assets/Illustrator-login.png";
import { FaEnvelope, FaLock } from "react-icons/fa";
import { motion } from "framer-motion";
import { useState } from "react";
import Cookies from "js-cookie";
import { CLSLogin } from "../../Services/LoginService";
import { useNavigate , Link} from "react-router-dom";

const CentralizedLoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [keepMeLoggedIn, setKeepMeLoggedIn] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const navigate = useNavigate();

  const handleLogin = async(e) =>{
    e.preventDefault();
    setError("");
    setSuccess("");

    if(!email || !password){
      setError("Please enter Both Email and Password.");
      return;
    }

    setLoading(true);
    try{
      const res = await CLSLogin(email, password, keepMeLoggedIn)
      if(res.status === "Success"){
        const token = res.userDetails?.token;
        const expiry = res.userDetails?.userTokenExpiry;
        Cookies.set("cls_token", token);

        setSuccess("Login Successfully!!");
        console.log("Token:", token, "Expiry:", expiry);
        navigate("/dashboard");
      }else{
        setError(res.message || "Login Failed!!");
      }
    }catch(err){
      setError(err.message)
    }
  }
  return (
    <div className="min-h-screen flex bg-gradient-to-br from-blue-50 via-blue-100 to-white text-gray-900 overflow-hidden">
      {/* Left Side - Login Form */}
      <motion.div
        initial={{ x: -80, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="flex-1 flex flex-col justify-center items-center px-8 md:px-16 relative overflow-hidden bg-gradient-to-br from-[#E8F1FF] via-[#F8FBFF] to-[#D6E9FF]"
      >
        {/* Soft radial light glow */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_30%,rgba(0,119,255,0.12),transparent_70%)]"></div>

        {/* Subtle Gradient Corners */}
        {/* <div className="absolute top-0 left-0 w-1/2 h-1/2 bg-gradient-to-br from-[#015db3] to-[#0b7ef9] rounded-br-full"></div> */}

        {/* Glassmorphism Login Card */}
        <motion.div
          initial={{ y: 40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.8, ease: "easeOut" }}
          whileHover={{ scale: 1.01 }}
          className="w-full max-w-md rounded-3xl shadow-xl p-10 bg-white/80 backdrop-blur-xl border border-blue-100 relative z-10 hover:shadow-blue-100/40 transition-all duration-300"
        >
          {/* Header */}
          <div className="text-center mb-8">
            <img
							src="https://www.vrsamadhantech.com/images/logo_home.png"
							alt="Logo"
							className="w-24 mx-auto mb-3 drop-shadow-md"
						/>
            <h2 className="text-3xl font-bold text-[#004687] tracking-tight">
              Centralized Login
            </h2>
            <div className="mt-2 w-16 h-[3px] bg-gradient-to-r from-[#004687] to-[#007BFF] mx-auto rounded-full"></div>
            <p className="text-gray-500 text-sm mt-2">
              Access your company and recruiter dashboards securely
            </p>
          </div>

          {/* Login Form */}
          <form className="space-y-5" onSubmit={handleLogin}>
            {/* Email */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Email
              </label>
              <div className="relative">
                <FaEnvelope className="absolute left-3 top-3.5 text-gray-400" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none transition-all hover:border-blue-400 shadow-sm"
                />
              </div>
            </div>

            {/* Password */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Password
              </label>
              <div className="relative">
                <FaLock className="absolute left-3 top-3.5 text-gray-400" />
                <input
                  type="password"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none transition-all hover:border-blue-400 shadow-sm"
                />
              </div>
            </div>

            {/* Remember Me + Forgot */}
            <div className="flex items-center justify-between text-sm">
              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={keepMeLoggedIn}
                  onChange={() => setKeepMeLoggedIn(!keepMeLoggedIn)}
                  className="accent-blue-600"
                />
                Remember me
              </label>
              <Link className="text-blue-600 hover:underline" 
              to="/Forgot-Password"
              >
                Forgot password?
              </Link>

            </div>

             {/* Feedback Messages */}
            {error && (
              <p className="text-red-500 text-sm text-center">{error}</p>
            )}
            {success && (
              <p className="text-green-600 text-sm text-center">{success}</p>
            )}


            {/* Button */}
            <motion.button
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
              type="submit"
              className="w-full bg-gradient-to-r from-[#004687] to-[#007BFF] text-white py-2.5 rounded-lg font-semibold shadow-lg hover:shadow-xl hover:opacity-95 transition-all"
            >
              Login
            </motion.button>
          </form>

          {/* Footer Note */}
          <p className="text-center text-gray-500 text-xs mt-6">
            © 2025 CLS | Secure Centralized Platform
          </p>
        </motion.div>
      </motion.div>

      {/* Right Side - Illustration / Info */}
      <motion.div
        initial={{ x: 80, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 1, ease: "easeOut" }}
        className="hidden md:flex flex-1 items-center justify-center p-10 bg-gradient-to-br from-[#004687] to-[#007BFF] text-white"
      >
        <div className="max-w-md text-center space-y-4">
          <motion.h2
            initial={{ y: -20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.8 }}
            className="text-3xl font-bold"
          >
            Welcome to the Centralized Login System
          </motion.h2>
          <motion.p
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.6, duration: 0.8 }}
            className="text-blue-100 text-sm"
          >
            Access all dashboards — Admin, Company, Recruiter, or Employee —
            from a single secure portal.
          </motion.p>
          <motion.img
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.8, duration: 1 }}
            src={IllustratorLogin}
            alt="Login Illustration"
            className="w-[500px] h-[400px] mx-auto mt-6 drop-shadow-lg object-contain"
          />
        </div>
      </motion.div>
    </div>
  );
};
export default CentralizedLoginPage;
